import { reportingService } from '../_services';

export const reports = {
  namespaced: true,
  state: {
    all: {},
    saved: null,
    serverProcessing: false,
    selectedPage: 1,
  },
  actions: {
    getAll({ commit }) {
      commit('getAllRequest');
      reportingService.getAll().then(
        response => {
          commit('getAllSuccess', response);
        }
      );
    },
    save({ commit }, data) {
      commit('saveRequest');
      let linksData = data;

      reportingService.save(linksData).then(
        response => {
          commit('saveSuccess', response.data);
        }
      );
    },
  },
  mutations: {
    getAllRequest(state) {
      state.all = { loading: true };
      state.serverProcessing = true;
      state.isDataLoaded = false;
    },
    setSelectedPage(state, page) {
      state.selectedPage = page;
    },
    getAllSuccess(state, data) {
      if (data.length) {
        data = data.map(e=>Object.assign(e,{title:`#${e.id} ${e.title}`}));
      }
      state.all = data;
      state.serverProcessing = false;
      state.isDataLoaded = true;
    },
    getAllFailure(state, error) {
      state.all = { error };
      state.serverProcessing = false;
    },
    saveRequest(state) {
      state.serverProcessing = true;
    },
    updateItem(state, data) {
      let tmpObj = data;
      if (Array.isArray(tmpObj)) {
        tmpObj = tmpObj[tmpObj.length - 1][0];
      }
      console.log('tmpObj', tmpObj);
    },
    saveSuccess(state, data) {
      let updatedData = data;
      if (Array.isArray(updatedData)) {
        updatedData = updatedData[updatedData.length - 1];
      }

      updatedData.map(el => {
        state.all.map(e => {
          if (e.id === el.id) {
            e = Object.assign(e, el);
          }
        });
      });
      state.saved = true;
      state.serverProcessing = false;
    },
    saveResetStatus(state) {
      state.saved = null;
    },
    saveFailure(state) {
      state.serverProcessing = false;
    },
  },
};
